import Swiper from "swiper/bundle";

const lightbox = {
  el: null,
  loading: false,
  slider: null,
  slider_dom: null,

  init: function () {
    this.gallery.init();
  },

  gallery: {
    init: function () {
      if ($(".gallery-slider").length) {
        // Make slider in content
        lightbox.gallery.content();
        // Load lightbox
        lightbox.load();
        // Add events
        lightbox.events();
        lightbox.gallery.events();
      }
    },

    content: function () {
      $(".gallery-slider").each(function (index) {
        var gallery_dom = $(this);

        //   Init content slider
        var navPrev = gallery_dom.find(".swiper-button-prev")[0];
        var navNext = gallery_dom.find(".swiper-button-next")[0];

        if (gallery_dom.children(".thumbs-container").length) {
          var thumbCount = gallery_dom
            .children(".thumbs-container")
            .find(".thumb-slide").length;

          var thumbSlides = Math.min(thumbCount, 5);

          var thumbsSwiper = new Swiper(
            gallery_dom.children(".thumbs-container")[0],
            {
              loop: true,
              slidesPerView: thumbSlides,
              centeredSlides: true,
              watchSlidesVisibility: false,
              slideToClickedSlide: true,
              lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: thumbSlides + 5,
              },
              spaceBetween: 8,
              touchRatio: 0.4,
              loopAdditionalSlides: 1,
            }
          );
        }

        var gallerySwiper = new Swiper(
          gallery_dom.children(".gallery-container")[0],
          {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            watchSlidesVisibility: false,
            lazy: {
              loadPrevNext: true,
              loadPrevNextAmount: 3,
            },
            navigation: {
              prevEl: navPrev,
              nextEl: navNext,
            },
            on: {
              init: function () {
                gallery_dom
                  .find(".gallery-wrapper")
                  .addClass("gallery-wrapper--loaded");
              },
            },
            loopAdditionalSlides: 5,
          }
        );

        if (gallery_dom.children(".thumbs-container").length) {
          thumbsSwiper.controller.control = gallerySwiper;
          gallerySwiper.controller.control = thumbsSwiper;
        }
      });
    },

    events: function () {
      // Expand image on click
      $("body").on("click", ".gallery-container img", function () {
        if ($(this).closest(".swiper-slide-active").length) {
          var gallery_dom = $(this).closest(".gallery-container");
          lightbox.gallery.open(gallery_dom);
        } else {
          if ($(this).closest(".swiper-slide-next").length) {
            $(this)
              .closest(".gallery-container")
              .find(".swiper-button-next")
              .click();
          }
          if ($(this).closest(".swiper-slide-prev").length) {
            $(this)
              .closest(".gallery-container")
              .find(".swiper-button-prev")
              .click();
          }
        }
      });

      // Expand image on Expand click
      $("body").on("click", ".gallery-slider__expand", function (e) {
        e.preventDefault();
        var slider = $(this).closest(".gallery-container");
        lightbox.gallery.open(slider);
      });
    },

    open: function (slider) {
      if (!lightbox.loading) {
        lightbox.loading = true;
        // Adds slides to slider
        var images = slider.attr("data-ids").split(",").map(Number);
        $.ajax({
          url: ajaxurl,
          data: {
            action: "lightbox_load_images",
            images: images,
          },
          type: "POST",
          success: function (response) {
            if (response.success) {
              lightbox.el.find(".lightbox-wrapper").html(response.data);
              // Disable scroll
              $("html").addClass("no-scroll");
              // Load swiper on lightbox
              lightbox.construct(slider);
            }
          },
        });
      }
    },
  },

  single: {
    init: function () {
      // Load lightbox
      lightbox.load();
      // Add events
      lightbox.events();
    },

    open: function (id) {
      if (!lightbox.loading) {
        lightbox.loading = true;
        // Adds slides to slider
        var images = [id];
        $.ajax({
          url: ajaxurl,
          data: {
            action: "lightbox_load_images",
            images: images,
          },
          type: "POST",
          success: function (response) {
            if (response.success) {
              lightbox.el.find(".lightbox-wrapper").html(response.data);
              // Disable scroll
              $("html").addClass("no-scroll");
              // Load swiper on lightbox
              lightbox.construct();
            }
          },
        });
      }
    },
  },

  load: function () {
    // Request lightbox
    $.ajax({
      url: ajaxurl,
      data: {
        action: "lightbox",
      },
      type: "POST",
      dataType: "JSON",
      success: function (response) {
        $(".main").append(response);
        lightbox.el = $("#lightbox");
        lightbox.slider_dom = lightbox.el.find(".lightbox-slider");
      },
    });
  },

  events: function () {
    // Close on X click
    $("body").on("click", ".lightbox-close", function (e) {
      e.preventDefault();
      lightbox.close();
    });

    // Close on ESC key
    $(document).keyup(function (e) {
      if (e.keyCode === 27) {
        lightbox.close();
      }
    });

    // Close if clicked outside of image
    $("body").on("click", ".lightbox-body", function (e) {
      var container = lightbox.el.find(".lightbox-container");
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        lightbox.close();
      }
    });

    // Gallery layout open lightbox
    $(".gallery-tiles .gallery-container").on("click", (e) => {
      const gallery_dom = $(e.currentTarget).closest(".gallery-slider");
      lightbox.gallery.open(gallery_dom);
    });
  },

  close: function () {
    // Destroy slider
    if (lightbox.slider) {
      lightbox.slider.destroy();
    }
    // Remove lightbox
    lightbox.el.removeClass("lightbox--open");
    // Allow scroll
    $("html").removeClass("no-scroll");
  },

  construct: function (slider) {
    // Init slider
    var nav_prev = lightbox.el.find(".swiper-button-prev")[0];
    var nav_next = lightbox.el.find(".swiper-button-next")[0];

    var options = {
      zoom: {
        maxRatio: 3,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      keyboard: {
        enabled: true,
      },
      on: {
        init: function () {
          // Open lightbox
          lightbox.el.addClass("lightbox--open");
          lightbox.loading = false;
        },
      },
    };

    // Set options if gallery.
    if (slider && slider[0].swiper) {
      lightbox.el.find(".lightbox-nav").show();

      options.initialSlide = slider[0].swiper.realIndex;
      options.loop = true;
      options.navigation = {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      };
    } else {
      lightbox.el.find(".lightbox-nav").hide();
    }

    lightbox.slider = new Swiper(lightbox.slider_dom[0], options);

    if (slider && slider[0].swiper) {
      lightbox.slider.on("slideChange", function () {
        // Sync with content
        var slide_to = this.realIndex;
        slider[0].swiper.slideToLoop(slide_to);
      });
    }
  },
};

export default lightbox;
